<template>
  <section>

      <Notification
              v-if="contents && (contents.status) && (!contents.batch_counts || contents.batch_counts <= 0 || contents.status === 'settled' || contents.status === 'success')"
              :type="state.newStatus || contents.status"
              @change="triggers(contents)"
              :no-text="state.activeTab === 'retries'"
      />

      <Notification
              v-else-if="contents && contents.status"
              type="batch_progress"
      />

    <div class="loading" v-if="contents.loading"><Loader /></div>

    <NoContent v-if="!contents.id && !contents.loading" />
    <div v-if="!contents.loading && contents.id">
      <div class="settlement-details">
        <div class="settlement-details__title">
          <h1  v-if="state.activeTab !== 'retries'"> Tranche Settlement Details</h1>
          <h1 v-else> Settlement Retry Details</h1>
          <p>Here's some information about your settlement.</p>
        </div>
        <div class="settlement-details__contents" v-if="state.activeTab !== 'retries'">
          <div class="settlement-details__contents__content"style="border: none">
            <p>Merchant Name</p>
            <h1>{{ contents.merchant_name || 'N/A' }}</h1>
          </div>

          <div class="settlement-details__contents__content"style="border: none">
            <p>User Message</p>
            <h1>{{ contents.user_message || contents.bank_response || 'N/A' }}</h1>
          </div>

          <div class="settlement-details__contents__content" style="border: none">
            <p>Settlment Reference</p>
            <div>{{ contents.settlement_reference || 'N/A' }}</div>
          </div>

          <div class="flex-center">
            <div>
              <div class="settlement-details__contents__content">
                <p>Settlement date</p>
                <div>{{ contents.date }}</div>
              </div>
              <div class="settlement-details__contents__content">
                <p>Created At </p>
                <div>{{ contents.createdAt || 'N/A' }}</div>
              </div>
              <div class="settlement-details__contents__content">
                <p>Updated at</p>
                <div>{{ contents.updatedAt || 'N/A' }}</div>
              </div>
            </div>

          </div>
          <div class="flex-center">
            <div>
              <div class="settlement-details__contents__content">
                <p>Retry Count </p>
                <div>{{ contents.retry_count }}</div>
              </div>
              <div class="settlement-details__contents__content">
                <p>Settlement Type</p>
                <div>{{ contents.settlement_type || 'N/A' }}</div>
              </div>
              <div class="settlement-details__contents__content">
                <p>Amount</p>
                <h1 class="amount">{{ contents.amount || 'N/A' }}</h1>
              </div>
            </div>

          </div>
        </div>

<!--        retry -->
        <div class="settlement-details__contents" v-else>
          <div class="settlement-details__contents__content" style="border: none">
            <p>Retry Message</p>
            <h1>{{ contents.user_message || contents.bank_response || 'N/A' }}</h1>
          </div>

          <div class="settlement-details__contents__content" style="border: none">
            <p>Retry Reference</p>
            <h1>{{ contents.settlement_retry_reference || 'N/A' }}</h1>
          </div>
          <div class="flex-center">
            <div>
              <div class="settlement-details__contents__content">
                <p>Retry date</p>
                <div>{{ contents.date }}</div>
              </div>
              <div class="settlement-details__contents__content">
                <p>Retry Type</p>
                <div>{{ contents.retry_type || 'N/A' }}</div>
              </div>
              <div class="settlement-details__contents__content">
                <p>Amount Payable</p>
                <h1 class="amount">{{ contents.amountPayable || 'N/A' }}</h1>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="settlement-details">
        <Table
          :handleExportDownload="handleExportDownload"
          :showExport="true"
          :contents="state.activeTab !== 'get-retries' ? contents.transactions : []"
          :title="`${(contents.pageInfo || {}).total || 0} Transactions`"
          :showFliter="state.showFliter"
          :pageInfo="contents.pageInfo || {}"
          :onPageChange="state.onPageChange"
          :noClickEvent="true"
          :clearFilter="clearFilter"
          :rowSelected="state.rowSelected"
          :hidePrimaryButton="true"
          :routerClickEvent="null"
          :loading="contents.tableLoading"
          toggleContent
          hideFilter
          :useQuery="false"
          :handlePageChange="handleApplyFliter"
        >
          <template v-slot:nocontent>
            <EmptyState type="transaction" noButton />
          </template>
          <template v-slot:filter>
            <div class="relative">
              <div class="text-light">
                <p>
                  Filter by :
                  <span @click="state.openFilters = !state.openFilters"
                    >All Transactions
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      :class="state.openFilters ? '' : 'rotate'"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="#e00b5b"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </p>
              </div>
              <div>
                <div
                  :class="state.openFilters ? 'blocker' : ''"
                  @click="hideFilter"
                ></div>
                <div class="filter-dropdown" v-if="state.openFilters">
                  <div class="filter-title">Transaction</div>
                  <div class="form__item">
                    <input
                      class="form__input"
                      type="text"
                      v-model="state.filter.transaction_reference"
                      placeholder="Reference"
                    />
                  </div>
                  <div class="form__item">
                    <input
                      class="form__input"
                      type="text"
                      v-model="state.filter.payer_name"
                      placeholder="Payer Name"
                    />
                  </div>
                  <div class="form__item">
                    <input
                      class="form__input"
                      type="text"
                      v-model="state.filter.destination_nuban"
                      placeholder="Payer Account"
                    />
                  </div>
                  <div class="form__item">
                    <input
                      class="form__input"
                      type="text"
                      v-model="state.filter.amount"
                      placeholder="Amount"
                    />
                  </div>
                  <div>
                    <div class="">
                      <p class="filter-title">Payer Date</p>
                      <input
                        placeholder="dd/mm/yyyy"
                        class="date margin-right"
                        type="date"
                        id="date"
                        v-model="state.filter.transaction_date"
                      />
                    </div>
                  </div>
                  <div class="button-group">
                    <button
                      class="btn woven-border-only woven-red"
                      @click="clearFilter"
                    >
                      Reset Filter
                    </button>
                    <button class="btn woven-color" @click="handleApplyFliter">
                      <p>Filter</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Table>
      </div>
      <div class="settlement-details">
        <Table
          hideFilter
          :contents="
            state.activeTab === 'get-retries' ?  retries.retries || [] : tranches.tranches || []
          "
:forceFilterSlot="true"
          :currentPage="state.currentPage"
          :title="state.trenchTitle"
          :showExport="false"
          :pageInfo="
            state.activeTab === 'get-retries'
              ? retries.page_info || {}
              : tranches.page_info
          "
          :onPageChange="state.onPageChange"
          :hidePrimaryButton="true"
          :loading="false"

          showTab
          :handlePrimaryButtonDisabled="false"
          :useQuery="false"
          :handlePageChange="handleSettlementBatchPageChange"
          :noClickEvent="false"

          :onRowChecked="onRowChecked"
          :rowSelected="rowSelected"
          :checkboxAll="checkboxAll"
          :checkboxNone="checkboxNone"

          singleDetailRouteName="settlements-list-details-batch"
          :paramsObject="{ type: state.activeTab  === 'get-retries' ? 'retries' : state.activeTab }"
        >
          <template v-slot:tab>
            <div style="padding: 0 40px; margin-top: -19px;">
              <Tab :tabs="state.tabs" />
            </div>
          </template>
          <template v-slot:nocontent>
            <EmptyState :type="state.activeTab === 'get-retries' ? 'retry': 'tranche'" />
          </template>
          <template v-slot:filter>
            <div class="relative">
              <div  style="position: absolute;top: 0; right: 0">
              <Button buttonName="Approve for processing"
                      classes="woven-color"
                      v-if="state.statusSelected === 'PROCESSING'"
                      :onClick="() =>approveSettlement(contents)"
              />
              <Button
                      v-else-if="state.statusSelected === 'FAILED'"
                    buttonName="Retry Tranches"
                    classes="woven-color"
                      :onClick="() =>triggerRetry(contents)"
            />
              </div>
            </div>
          </template>

        </Table>
      </div>
    </div>
    <!-- modal  -->
    <div v-if="modal.show">
      <Modal classes="settlement-tranches" :styleClass="modal.styleClass">
        <template v-slot:content>
          <div
            style="
              color: #fff;
              cursor: pointer;
              text-align: right;
              margin: 10px 35px;
            "
            @click="triggerRetry"
          >
            Close x
          </div>
          <div class="settlement-tranches__content">
            <div class="boxed">
              <svg
                width="60"
                height="61"
                viewBox="0 0 60 61"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M57.5 27.501C56.12 27.501 55 28.621 55 30.001C55 43.786 43.785 55.001 30 55.001C16.215 55.001 5 43.786 5 30.001C5 16.216 16.215 5.00102 30 5.00102C34.57 5.00102 39.135 6.28102 43.0725 8.50352L39.8425 11.7335C39.1275 12.4485 38.9125 13.5235 39.3 14.4585C39.6875 15.391 40.6 16.001 41.6125 16.001H52.6125C53.9925 16.001 55.1125 14.881 55.1125 13.501V2.50102C55.1125 1.49102 54.5025 0.578524 53.57 0.191024C52.6325 -0.196477 51.56 0.0160235 50.845 0.733524L46.735 4.84352C41.815 1.75352 35.9825 0.00102351 30 0.00102351C13.4575 0.00102351 0 13.4585 0 30.001C0 46.5435 13.4575 60.001 30 60.001C46.5425 60.001 60 46.5435 60 30.001C60 28.621 58.88 27.501 57.5 27.501Z"
                  fill="#e00b5b"
                />
                <path
                  d="M46.25 30.001C46.25 38.976 38.975 46.251 30 46.251C21.025 46.251 13.75 38.976 13.75 30.001C13.75 21.026 21.025 13.751 30 13.751C38.975 13.751 46.25 21.026 46.25 30.001Z"
                  fill="#e00b5b"
                />
                <path
                  d="M36.8751 32.741C36.8751 31.396 36.2576 30.2085 35.3151 29.431C35.6851 28.791 35.9126 28.046 35.9126 27.241C35.9126 25.3385 34.6926 23.7435 33.0276 23.2085V21.501C33.0276 20.671 32.3826 20.001 31.5851 20.001C30.7876 20.001 30.1426 20.6735 30.1426 21.501V23.001H29.1801V21.501C29.1801 20.671 28.5351 20.001 27.7376 20.001C26.9401 20.001 26.2951 20.6735 26.2951 21.501V23.001H25.8151C25.0176 23.001 24.3726 23.6735 24.3726 24.501V30.001V35.501C24.3726 36.3285 25.0176 37.001 25.8151 37.001H26.2951V38.501C26.2951 39.331 26.9426 40.001 27.7376 40.001C28.5326 40.001 29.1801 39.3285 29.1801 38.501V37.001H30.1426V38.501C30.1426 39.331 30.7876 40.001 31.5851 40.001C32.3801 40.001 33.0276 39.3285 33.0276 38.501V36.976C35.1676 36.8485 36.8751 35.016 36.8751 32.741ZM27.2601 26.001H31.8376C32.4951 26.001 33.0301 26.5585 33.0301 27.261C33.0301 27.9435 32.4951 28.501 31.8376 28.501H27.2601V26.001ZM32.7976 34.001H27.2601V31.501H31.8376H32.8001C33.4576 31.501 33.9926 32.0585 33.9926 32.761C33.9901 33.4435 33.4551 34.001 32.7976 34.001Z"
                  fill="#B6E4E9"
                />
                <path
                  d="M30.0024 0.00390625H29.5274C13.3599 0.253906 0.252441 13.3589 0.00244141 29.5289V30.4739C0.257441 46.7989 13.6149 60.0014 29.9999 60.0014H30.0024V55.0014H29.9999C16.2149 55.0014 4.99994 43.7864 4.99994 30.0014C4.99994 16.2164 16.2149 5.00141 29.9999 5.00141H30.0024V0.00390625Z"
                  fill="#FFDADB"
                />
                <path
                  d="M30.0025 31.501H27.2575V34.001H30.0025V31.501ZM30.0025 26.001H27.2575V28.501H30.0025V26.001ZM30 13.751C21.025 13.751 13.75 21.026 13.75 30.001C13.75 38.976 21.025 46.251 30 46.251H30.0025V37.001H29.18V38.501C29.18 39.331 28.535 40.001 27.7375 40.001C26.94 40.001 26.295 39.3285 26.295 38.501V37.001H25.815C25.0175 37.001 24.3725 36.3285 24.3725 35.501V30.001V24.501C24.3725 23.6735 25.0175 23.001 25.815 23.001H26.295V21.501C26.295 20.671 26.9425 20.001 27.7375 20.001C28.5325 20.001 29.18 20.6735 29.18 21.501V23.001H30.0025V13.751H30Z"
                  fill="#FFDADB"
                />
                <path
                  d="M27.74 20.001C26.945 20.001 26.2975 20.6735 26.2975 21.501V23.001H25.8175C25.02 23.001 24.375 23.6735 24.375 24.501V30.001V35.501C24.375 36.3285 25.02 37.001 25.8175 37.001H26.2975V38.501C26.2975 39.331 26.945 40.001 27.74 40.001C28.535 40.001 29.1825 39.3285 29.1825 38.501V37.001H30.005V34.001H27.26V31.501H30.005V28.501H27.26V26.001H30.005V23.001H29.1825V21.501C29.1825 20.6735 28.5375 20.001 27.74 20.001Z"
                  fill="#B4D2D7"
                />
              </svg>

              <h1>Confirm Retry</h1>
              <br />
              <br />

              <div>
                You can change details to retry your settlement. These details
                will be updated accordingly.
              </div>

              <br />
              <br />
              <div class="form__item disabled_feel">
                <label class="form__label" for>Account Number</label>
                <input
                  class="form__input"
                  type="text"
                  readonly
                  :value="modal.transaction.bank"
                />
              </div>
              <div class="form__item disabled_feel">
                <label class="form__label" for>Destination Bank</label>
                <input
                  class="form__input"
                  type="text"
                  readonly
                  :value="modal.transaction.settlement_nuban"
                />
              </div>
              <div class="form__item disabled_feel">
                <label class="form__label" for>Amount</label>
                <input
                  class="form__input"
                  type="text"
                  readonly
                  :value="modal.transaction.amount"
                />
              </div>

              <button
                class="btn woven-color text-white width-100"
                @click="retrySettlement"
                :disabled="modal.loading"
              >
                Retry Settlement
              </button>
            </div>
            <!-- End specific transaction details -->
            <WovenStrip :loading="modal.loading" />
          </div>
        </template>
      </Modal>
    </div>



  </section>
</template>

<script>
import { reactive, onBeforeMount, computed, watch, onUpdated } from "@vue/composition-api";
import Table from "@/components/table.vue";
import Input from "@/components/input.vue";
import Datepicker from "@/components/datepicker.vue";
import Button from "@/components/button.vue";
import Loader from "@/components/loader.vue";
import NoContent from "@/components/noContent.vue";
import { capitalizeFirstLetter } from "@/lib/formatKeysToPascalCase";
import { pdfExport, csvExport } from "@/lib/download.js";
import { formatKeysToPascalCase } from "@/lib/formatKeysToPascalCase";
import Notification from "@/components/notification.vue";
import Modal from "../../../components/modalv2";
import WovenStrip from "@/components/wovenstrip.vue";
import InputV2 from "@/components/inputv2.vue";
import Tab from "@/components/tab.vue";
import Vue from "vue";
import EmptyState from "../../../components/empty-state";

export default {
  setup(props, { root }) {
    const store = root.$store;
    const state = reactive({
      id: "",
      title: "",
      showFliter: true,
      onPageChange: () => {},
      filter: {
        payer_name: "",
        transaction_reference: "",
        destination_nuban: "",
        amount: "",
        transaction_date: "",
      },
      showDropdown: false,
      dropdowns: [
        {
          id: "cancelled",
          value: "Cancelled",
          icon: "cancel.svg",
        },
        {
          id: "failed",
          value: "Failed",
          icon: "failed.svg",
        },
        {
          id: "completed",
          value: "Completed",
          icon: "check-circle.svg",
        },
      ],
      statusSelected: "",
      openFilters: false,
      currentPage: 1,
      trenchTitle: "",
      pageInfo: {},
      loading: false,
      settlement_status: true,
      tabs: [],
      activeTab: root.$route.params.type || "get-retries",
      selectedStatus: null,
      newStatus: null
    });

    watch(
      () => root.$route.params.type,
      (val) => {
        state.activeTab = val;
        checkboxNone()
      }
    );

    watch(
      () => root.$route.params.id,
      (val) => {
        state.id = val;
      }
    );

    onBeforeMount(() => {
      state.tabs = [
        {
          url: `/dashboard/settlements/batch/details/${root.$route.params.id}/get-retries`,
          name: `Settlement Retries`,
        },
        {
          url: `/dashboard/settlements/batch/details/${root.$route.params.id}/tranches`,
          name: "Tranches",
        },
      ];
      // store.commit("setSettlementBatchDetail", { loading: true });
      state.id = root.$route.params.id;
      if (root.$route.params.type.toLowerCase() === 'retries') {
        root.$route.params.type = 'retry';
      } else {
        root.$route.params.type = 'batch';
        store.dispatch("getSettlementTranches", {
          reference: root.$route.params.id,
        });
        store.dispatch("getSettlementRetries", {
          reference: root.$route.params.id,
          type: 'batch'
        });
      }
      store.dispatch("getSettlementBatchDetails", root.$route.params);
    });

    const contents = computed(() => store.getters.getSettlementBatchDetails);
    const allTranches = computed(() => store.getters.getSettlementTranches);
    const retries = computed(() => store.getters.getSettlementRetries);
    const rowSelected = computed(() => store.getters.getRowSelected);


    let tranches = allTranches;
    const handleRedirect = () =>
      root.$options.router.push("/dashboard/settlements/processed");

    const handleApplyFliter = (page) => {
      store.dispatch("getSettlementBatchDetails", {
        ...state.filter,
        ...(page ? { page } : {}),
        id: state.id,
      });
    };

    const onSelected = (status) => {
      state.showDropdown = false;
      state.statusSelected = status;
    };
    const clearFilter = () => {
      state.filter = {
        unique_reference: " ",
        source_nuban: " ",
        destination_nuban: " ",
        merchant_id: " ",
        net_amount: " ",
        transaction_time: " ",
      };
      store.dispatch("getSettlementBatchDetails", { id: state.id });
    };
    const handleStatusChange = () =>
      store.dispatch("setSettlementScheduleStatus", {
        id: contents.value.id,
        status: state.statusSelected,
      });
    const handleExportDownload = (type) => {
      let downloadObject = {
        download: "true",
        downloadType: type,
        settlement_status: root.$route.params.type,
        ...state.appliedFilter,
      };
      if (state.settlement_status) {
        downloadObject.download = 1;
      }

      switch (type) {
        case "pdf":
          pdfExport(formatKeysToPascalCase(contents.value.transactions));
          break;
        case "csv":
          csvExport(formatKeysToPascalCase(contents.value.transactions));
          break;
        default:
          break;
      }
    };
    const modal = reactive({
      show: false,
      type: 1,
      transaction: {},
      styleClass: "",
      loading: false,
    });
    const triggerRetry = (item) => {
      if (!rowSelected.value.length && item.batch_counts) {
        return Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Batch retry",
          text: 'You need to select rows to retry.',
        });
      }
      modal.show = !modal.show;
      modal.transaction = item;
      modal.loading = false;
      modal.styleClass =
        modal.styleClass === "display: block"
          ? "display: none !important"
          : "display: block";
    };

    const triggers = (item) => {
      if (item.status === 'failed') {
        return triggerRetry(item);
      }
      return approveSettlement(item);
    }
    const retrySettlement = () => {
      modal.loading = true;
        store.dispatch("retrySettlementBatch", {
          settlement_references: [ modal.transaction.settlement_reference],
          reload: true
        });

      setTimeout(() => {
        state.newStatus = 'pending'
        triggerRetry(modal.transaction)
        checkboxNone()
      }, 1000);
    };


    const approveSettlement = (transaction) => {
      modal.loading = true;
      Vue.notify({
        group: "notifications-default",
        type: "warning text-white",
        title: "Settlement retry",
        text: "Settlement approval has been initiated."
      });
        store.dispatch("retrySettlementBatch", {
          settlement_references: [transaction.settlement_reference],
          approval: true
        });
      setTimeout(() => {
        state.newStatus = 'pending'
        checkboxNone()
      }, 500);
    };

    const hideFilter = () => {
      state.openFilters = false;
    };
    const handleSettlementBatchPageChange = (page) => {
      store.dispatch("getSettlementTranches", { page, reference: state.id });
    };

    const onPageChange = () => {};

    const onRowChecked = ({ value, id }) => {
      const selectedTranch = allTranches.value.tranches.filter(tran =>  tran.id === id)[0];
      const status = selectedTranch.status || selectedTranch.STATUS;

      if (value && (state.statusSelected === status || !state.statusSelected)) {
        // const newTranches = allTranches.value.tranches.filter(tran =>  String(tran.STATUS).toUpperCase() === status.toUpperCase())
        // const tranch = allTranches;
        // tranch.value.tranches =  newTranches
        // tranches = tranch
        state.statusSelected = status
      } else {
        // tranches = allTranches
        state.statusSelected = null
      }
      store.commit("setRowSelected", { value, id });

    };


    const checkboxAll = () => {
      // const rows = state.activeTab === 'retries' ? retries.value.retries  || [] : tranches.value.tranches
      // store.commit("setSelectAllRows", { rows: rows.map(({id}) => ({ value: false, id })) });
    };

    const checkboxNone = () => store.commit("setRowSelected", { type: "none" });


    return {
      state,
      handleRedirect,
      contents,
      handleApplyFliter,
      clearFilter,
      onSelected,
      handleStatusChange,
      capitalizeFirstLetter,
      handleExportDownload,
      triggerRetry,
      retrySettlement,
      modal,
      hideFilter,
      onPageChange,
      tranches,
      handleSettlementBatchPageChange,
      retries,onRowChecked, rowSelected, checkboxNone, checkboxAll,approveSettlement, triggers
    };
  },
  components: {
    EmptyState,
    Table,
    Input,
    Datepicker,
    Button,
    Loader,
    NoContent,
    Notification,
    Modal,
    WovenStrip,
    InputV2,
    Tab,
  },
  metaInfo: {
    title: "Settlements Details",
  },
};
</script>

<style lang="scss">
.width-100 {
  width: 100% !important;
}
.header {
  padding: 30px 0 30px 25px;
  > p {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1em;
    color: rgba(101, 93, 121, 0.7);
  }
  > div {
    display: flex;
    margin-top: 49px;
    svg {
      cursor: pointer;
    }
    p {
      margin-left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #261940;
    }
  }
}
.loading {
  margin: 10px 30px;
}
.button-image {
  margin-right: 5px;
}
.settlement-details:nth-child(1) {
  padding: 45px;
}
.settlement-details {
  font-family: 'Calibre' !important;
  background: #fff;
  display: flex;
  justify-content: space-between;
  margin: 32px 25px;
  overflow: hidden;
  &:hover {
    overflow-x: auto;
  }
  &__title {
    h1 {
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 23px;
      color: #7a153c;
      margin-bottom: 12px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
      color: #616e7c;
      max-width: 189px;
    }
  }
  .table-component {
    margin: 0 !important;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    width: 100%;
  }
  .tab__content {
    margin: 0;
    &__top {
      padding: 0;
      margin: 19px;
    }
  }
  .filter {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 0 24px;
    .button-comp {
      margin-left: 20px;
      margin-bottom: 30px;
    }
  }
  .flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    > div {
      display: flex;
    }
  }
  &__contents {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 6px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom: none;
    > div {
      display: flex;
      padding-bottom: 35px;
    }
    .btn {
      width: 171px;
      margin-top: 20px;
      .btn--text {
        flex-grow: 1;
      }
    }
    .dropdown {
      width: 171px;
    }
    &__content:not(:last-child) {
      border-right: 0.5px solid rgba(38, 25, 64, 0.15);
      margin-right: 50px;
    }
    &__content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 200px;
      h1 {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 22px;
        color: #261940;
        opacity: 0.8;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: rgba(38, 25, 64, 0.7);
        margin-bottom: 8px;
      }
      .btn--sm {
        width: 171px;
      }
      .amount {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 23px;
        color: #38091b;
        opacity: 0.8;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// filter styles start
.relative {
  position: relative;
}
.end-date {
  margin-top: 15px;
}
.rotate {
  transform: rotate(180deg);
}
.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 40px;
  svg {
    margin-right: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}
.woven-strip {
  position: absolute;
  left: 0;
}
.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;
  svg {
    margin-left: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}
.filter-dropdown {
  background: #fff;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  right: 0;
  min-width: 300px;
  .form__item {
    margin-bottom: 16px;
  }
}
.woven-red {
  color: #e00b5b;
}
.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);
  p {
    width: 100%;
  }
  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}
.date-group {
  display: flex;
}
.margin-right {
  margin-right: 16px;
}
.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  width: 100%;
}
.status-element {
  display: flex;
  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}
.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  span {
    color: #e00b5b;
    cursor: pointer;
  }
}
.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  // margin-bottom: 16px;
  margin: 5px 0;
}
// filter styles end
.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;
  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
</style>

<style lang="scss" scoped>
.disabled_feel {
  background: rgba(196, 196, 196, 0.1);
  border: 0.5px solid rgba(97, 110, 124, 0.25);
  box-sizing: border-box;
  border-radius: 4px;
  height: 56px;
  text-align: left;
}
.form__input,
.form__label {
  background: transparent;
  color: #3c3f43;
  text-align: left;
}
.form__label {
  color: #616e7c;
}
.boxed {
  min-width: 200px;
  padding: 10%;
}

.settlement-tranches {
  max-width: 520px !important;
  max-height: 80vh;
  width: 100% !important;
  height: 80vh;
  padding: 0;
  position: relative;
  overflow: hidden;
  &__content {
    overflow: hidden;
    min-width: 200px;
    min-height: 200px;
    position: relative;
  }
  .modal {
    height: 80vh;
    padding: 0;
    display: block !important;
  }
  &.modal-content,
  &__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #ffffff !important;
    border-radius: 10px 10px 0px 0px;
    max-width: 90%;
    width: 100% !important;
    height: 100% !important;
    margin: auto;
    text-align: center;
    padding: 15px 0;
    &__transaction_item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      border-bottom: 1px solid #ebf0f4;
      padding: 20px 0;
      &__top {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.5);
        padding: 10px 0;
      }
      &__info {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 18px;
        color: #261940;
      }
    }
  }
  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    color: #000000;
  }
}
</style>